import { api } from "@/src/services/api";

const ABSOLUTE_URL_REGEX = /^(?:https?:)?\/\//i;

/**
 * Safely parse JSON from localStorage or any string source.
 * Returns fallback value if parsing fails or input is null/undefined.
 */
export function safeJsonParse<T>(
  json: string | null | undefined,
  fallback: T,
): T {
  if (!json) return fallback;
  try {
    const parsed = JSON.parse(json);
    return parsed == null ? fallback : (parsed as T);
  } catch (error) {
    console.error("Failed to parse JSON:", error);
    return fallback;
  }
}

export function buildStorageUrl(path?: string | null): string {
  if (!path) {
    return "";
  }

  if (ABSOLUTE_URL_REGEX.test(path) || path.startsWith("data:")) {
    return path;
  }

  const baseApiUrl = api.defaults.baseURL || "";
  const baseWithoutApi = baseApiUrl
    ? baseApiUrl.replace(/\/api\/?$/, "")
    : typeof window !== "undefined"
      ? window.location.origin
      : "";

  const sanitizedBase = (baseWithoutApi || "").replace(/\/$/, "");
  const normalizedPath = path.startsWith("storage/")
    ? path.replace(/^storage\//, "")
    : path.replace(/^\/+/, "");

  return `${sanitizedBase}/storage/${normalizedPath}`;
}
